import { useEffect, useState } from 'react';
import { listBeerIngestion } from '../services/beerIngestionService';
import { captureBeerIngestionViewScoreboard } from '../utils/beerIngestionAnalytics';

export default function useBeerIngestionPilotScoreboard(stateCode, enabled) {
  const [scoreboard, setScoreboard] = useState(null);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(Boolean(enabled && stateCode));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !stateCode) {
      setScoreboard(null);
      setSummary(null);
      setLoading(false);
      setError(null);
      return undefined;
    }

    let cancelled = false;
    const loadScoreboard = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await listBeerIngestion(stateCode, {
          includePilotScoreboard: true,
        });
        if (cancelled) {
          return;
        }
        setScoreboard(result.pilotScoreboard);
        setSummary(result.summary);
        captureBeerIngestionViewScoreboard(
          stateCode,
          result.pilotScoreboard?.trusted?.percent ?? result.summary?.trustedPercent ?? 0,
          result.pilotScoreboard?.trusted?.met === true,
        );
      } catch (loadError) {
        if (cancelled) {
          return;
        }
        setError(loadError?.message || 'Failed to load pilot scoreboard');
        setScoreboard(null);
        setSummary(null);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    loadScoreboard();
    return () => {
      cancelled = true;
    };
  }, [enabled, stateCode]);

  return {
    scoreboard,
    summary,
    loading,
    error,
  };
}
